import { modalTypes } from "constants/types";
import { noop } from "lodash";
import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { showModal } from "slices/app/actions/modals";
import { deleteWatchwordsListById } from "slices/watchwords/list/actions";

const useDeleteWatchwordsListHandler = ({
  id: listId,
  name,
  onComplete = noop,
}) => {
  const dispatch = useDispatch();

  const onConfirmDelete = async () => {
    await dispatch(deleteWatchwordsListById(listId));
    onComplete();
  };

  return useCallback(
    (e) => {
      e.stopPropagation();
      dispatch(
        showModal(modalTypes.GENERIC_DELETE_MODAL, {
          onConfirmDelete,
          target: name,
          type: "Watchword List",
        })
      );
    },
    [listId, name]
  );
};

export default useDeleteWatchwordsListHandler;
